import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { DetailsPageLayout } from '../../../components'
import FlowCytometryReviewAnalysisSmartFunctionDetailsPageHeader from './components/FlowCytometryReviewAnalysisSmartFunctionDetailsPageHeader'
import { flowCytometryReviewAnalysisPanels } from './components/FlowCytometryReviewAnalysisSelectPanel'
import FlowCytometryReviewAnalysisGateReviewPanel from './panels/FlowCytometryReviewAnalysisGateReviewPanel'
import FlowCytometryReviewAnalysisCompensationMatrixReviewPanel from './panels/FlowCytometryReviewAnalysisCompensationMatrixReviewPanel'
import FlowCytometryReviewAnalysisGateLockReviewPanel from './panels/FlowCytometryReviewAnalysisGateLockReviewPanel'
import FlowCytometryReviewAnalysisAdditionalAnalysisFileReviewPanel from './panels/FlowCytometryReviewAnalysisAdditionalAnalysisFileReviewPanel'
import { smartFunctionViewTypes } from '../components/SmartFunctionViewTypeDropdown'
import FlowCytometryReviewAnalysisReportPanel from './panels/FlowCytometryReviewAnalysisReportPanel'

const FlowCytometryReviewAnalysisSmartFunctionDetailsPage = () => {
  const { viewType, panel } = useParams()

  const panelIndex = useMemo(() => {
    if (viewType === smartFunctionViewTypes.REPORT) {
      return 4
    } else {
      switch (panel) {
        case flowCytometryReviewAnalysisPanels.GATE_REVIEW:
          return 0
        case flowCytometryReviewAnalysisPanels.COMPENSATION_MATRIX_REVIEW:
          return 1
        case flowCytometryReviewAnalysisPanels.GATE_LOCK_REVIEW:
          return 2
        case flowCytometryReviewAnalysisPanels.ADDITIONAL_ANALYSIS_FILE_REVIEW:
          return 3
      }
    }
    return 0
  }, [panel, viewType])

  const panels = useMemo(
    () => [
      <FlowCytometryReviewAnalysisGateReviewPanel />,
      <FlowCytometryReviewAnalysisCompensationMatrixReviewPanel />,
      <FlowCytometryReviewAnalysisGateLockReviewPanel />,
      <FlowCytometryReviewAnalysisAdditionalAnalysisFileReviewPanel />,
      <FlowCytometryReviewAnalysisReportPanel />,
    ],
    [],
  )

  return (
    <DetailsPageLayout>
      <FlowCytometryReviewAnalysisSmartFunctionDetailsPageHeader />
      {panels[panelIndex]}
    </DetailsPageLayout>
  )
}

export default FlowCytometryReviewAnalysisSmartFunctionDetailsPage
